<template>
  <div>
    <!-- <loader-ring></loader-ring> -->
    <div>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Referrals</h1>
        </div>
      </div>
      <div class="row align-items-end my-4">
        <div class="col-xl-3 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Start Date</label>
            <input type="date" class="form-control" v-model="start_date" />
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Stop Date</label>
            <input type="date" class="form-control" v-model="stop_date" />
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Search</label>
            <input type="text" class="form-control" v-model="search" />
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-12 px--5">
          <div class="form-group">
            <button class="button btn">
              <!-- <span class="custom-loader" v-if="reportsLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">
              Fetching Reports...
            </span>
          </span> -->
              <span>
                Submit
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h3 class="card-title">Referrals</h3>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="referrals"
              :fields="fields"
              :items-per-page="small ? 20 : 5"
              pagination
              sorter
              tableFilter
            >
              <template #first_name="{ item }">
                <td>
                  {{ item.user.first_name }}
                </td>
              </template>
              <template #last_name="{ item }">
                <td>
                  {{ item.user.last_name }}
                </td>
              </template>
              <template #referrals="{ item }">
                <td>
                  {{ item.referrals }}
                </td>
              </template>
              <template #phone_number="{ item }">
                <td>
                  {{ item.user.phone_number }}
                </td>
              </template>
              <template #created_at="{item}">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template>
              <template #actions="{item}">
                <!-- <td>{{ item.created_at | date }}</td> -->
                <td class="table--action-mobile">
                  <router-link
                    class="button"
                    :to="{
                      name: 'CustomerComponent',
                      params: { slug: item.user.customer_id }
                    }"
                  >
                    View Customer
                  </router-link>
                </td>
              </template>
            </CDataTable>
            <!-- <CPagination
              :activePage.sync="next_page"
              :pages="total"
              :onActivePageChange="onPageChange()"
            ></CPagination> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import CPagination from "@/components/CPagination";
const fields = [
  "first_name",
  "last_name",
  "referrals",
  "phone_number",
  "actions"
];
export default {
  name: "Referral",
  components: { CDataTable, CPagination },
  data() {
    return {
      referrals: [],
      refLoading: false,
      fields,
      small: true,
      start_date: "",
      stop_date: "",
      search: ""
    };
  },
  methods: {
    async getReferral() {
      try {
        const response = await ApiService.get("backend/customers/referrals");

        this.referrals = response.data.data;
        this.refLoading = false;
      } catch (error) {
        console.log(error.response);
        this.refLoading = false;
      }
    }
  },
  mounted() {
    this.refLoading = true;
    this.getReferral();
  }
};
</script>

<style scoped></style>
